var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.IsShow)?_c('div',{staticClass:"mask"},[_c('div',{staticClass:"box",class:_vm.ProList.length > 0 && _vm.ProList.length < 3 ? 'two':'four'},[_c('productList',{staticClass:"product",attrs:{"IsPopup":false,"productList":_vm.ProList}}),_vm._v(" "),_c('div',{staticClass:"close",on:{"click":_vm.close}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51fae708","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultipleSpecifications.vue
// module id = null
// module chunks = 